export default {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: false,
};
